export default class Banner {

    constructor() {
        this.title = ''
        this.message = ''
        this.active = false
    }

}
